import { initUrl } from '@/config/axios_config'


/**************登录API*******************/
//POST登录接口
export const doLogin = data => initUrl(`/rest/login`, data, 'POST')

///rest/logout 退出登录
export const logout = data => initUrl(`/rest/logout`, data, 'POST')


///api/sso/login Token登录 单点登录(从医院的统一认证平台-柯林布瑞-进行登录)
export const loginPatientCenter = data => initUrl(`/sso/loginByPatientCenter`, data, 'POST')


export const getAccessTokenOfWechet = data => initUrl(`/faceRecognition/getAccessToken`, data, 'GET')

///api/syncData/syncUsingOutData 是否开启使用患者中心的数据（包括患者、住院、床号、用户、科室、角色等信息）
export const syncUsingOutData = data => initUrl(`/syncData/syncUsingOutData`, data, 'GET')


// WEBPACK FOOTER //
// ./src/api/loginApi.js